import React from 'react';
import { motion } from 'framer-motion';
export function ForYou() {
  const painPoints: {
    emoji: string;
    content: React.ReactNode;
  }[] = [{
    emoji: '😩',
    content: <>
          Si estás{' '}
          <strong className="font-bold text-deep-black" data-id="element-145">
            harta de escribir primero
          </strong>
          , de proponer planes y de ser siempre la que más pone.
        </>
  }, {
    emoji: '👻',
    content: <>
          Te{' '}
          <span className="bg-gold/25 px-1 rounded-sm font-semibold text-deep-black" data-id="element-146">
            ghostean
          </span>{' '}
          justo cuando empezás a ilusionarte o te dejan en visto después de
          semanas.
        </>
  }, {
    emoji: '🌀',
    content: <>
          No podés parar de{' '}
          <strong className="font-bold text-deep-black" data-id="element-147">sobrepensar</strong>{' '}
          cada mensaje, cada silencio y cada “estoy ocupado”.
        </>
  }, {
    emoji: '🥀',
    content: <>
          Perseguís{' '}
          <em className="not-italic underline decoration-bordeaux/40 decoration-2 underline-offset-2" data-id="element-148">
            migajas de atención
          </em>{' '}
          mientras él mantiene el control.
        </>
  }, {
    emoji: '💔',
    content: <>
          Te sentís{' '}
          <strong className="font-bold text-deep-black" data-id="element-149">
            “demasiado intensa”
          </strong>{' '}
          o{' '}
          <strong className="font-bold text-deep-black" data-id="element-150">“no suficiente”</strong>
          .
        </>
  }];
  return <section className="py-14 bg-[#FAFAFA]" data-id="element-151">
      <div className="max-w-3xl mx-auto px-6" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8 flex justify-center" data-id="element-153">
          <img src="https://cdn.magicpatterns.com/uploads/2JiuDAGUn7qKsBn4aZfS26/Captura_de_pantalla_2026-05-11_a_la(s)_7.47.06_p._m..png" alt="Mensaje de WhatsApp: te extraño" className="w-full max-w-md lg:max-w-lg xl:max-w-xl h-auto rounded-lg shadow-lg" data-id="element-154" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-155">
          <h2 className="text-3xl sm:text-4xl font-playfair text-deep-black mb-4" data-id="element-156">
            Esto es para vos…
          </h2>
          <div className="w-16 h-0.5 bg-bordeaux mx-auto" data-id="element-157"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-158">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="flex items-start bg-white p-6 shadow-sm border border-gray-100" data-id="element-159">
              <span className="text-2xl mr-4 flex-shrink-0 mt-0.5 leading-none" aria-hidden="true" data-id="element-160">
                {point.emoji}
              </span>
              <p className="text-gray-800 font-inter text-lg leading-relaxed" data-id="element-161">
                {point.content}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="mt-10 text-center" data-id="element-162"></motion.div>
      </div>
    </section>;
}